import { useEffect } from "react"

export default function PrivacyPolicy() {
  useEffect(() => {
    // Redirect to external privacy policy
    window.location.href = "https://www.getvibrato.com/c/privacy"
  }, [])

  return (
    <div className="w-full p-8 flex items-center justify-center">
      <p className="text-lg">Redirecting to privacy policy...</p>
    </div>
  )
}
